import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const PatientAppointment = React.lazy(() =>
  import('../../views/PatientAppointment')
);

const params = [];

const PatientAppointmentRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <PatientAppointment />
      </Layout>
    </RouteParameter>
  );
};

PatientAppointmentRoute.propTypes = {};

PatientAppointmentRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(PatientAppointmentRoute);
